<script setup>
import { ref } from 'vue';
import { useForm } from 'vee-validate';
import { signupSchema } from '@/validations/auth.js';
import { signUpWithEmail } from '@/api/loginApi.js';
import { useRouter } from 'vue-router';
import IconError from '~icons/svg/error';
import AuthFormLayout from './AuthFormLayout.vue';
import ToastMessage from '../common/ToastMessage.vue';

const router = useRouter();
const isProcessing = ref(false);

// inputの入力値
const { handleSubmit, errors, defineField } = useForm({
  validationSchema: signupSchema,
});

const [email, emailAttrs] = defineField('email');
const [username, usernameAttrs] = defineField('username');
const [password, passwordAttrs] = defineField('password');

//ログインエラーメッセージ
const loginError = ref('');

const handleSignUp = handleSubmit(async (form) => {
  isProcessing.value = true;

  try {
    await signUpWithEmail(form);
    router.push('/todo');
  } catch (error) {
    loginError.value = '登録できませんでした';
    console.error(error);
  } finally {
    isProcessing.value = false;
  }
});
</script>
<template>
  <AuthFormLayout>
    <ToastMessage :show="!!loginError" type="error">
      <template #icon>
        <IconError />
      </template>

      {{ loginError }}
    </ToastMessage>
    <template #title>
      <h2 class="text-2xl pb-1">登録</h2>
    </template>
    <form
      @submit.prevent="handleSignUp"
      class="p-6 md:p-10 grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-y-6 md:gap-y-10 items-center"
    >
      <label for="username" class="md:ms-auto md:w-25 md:pr-4 text-start md:text-right">名前</label>
      <div class="relative">
        <input
          v-model="username"
          v-bind="usernameAttrs"
          id="username"
          type="text"
          name="username"
          placeholder="hogehoge"
          autocomplete="given-name"
          class="w-full border rounded-sm px-2 py-1 focus:outline-offset-2 focus:outline-4"
          :class="
            errors.username
              ? 'border-red-500 focus:outline-red-400'
              : 'border-gray-500 focus:outline-emerald-400'
          "
        />
        <p v-if="errors.username" class="absolute text-red-500 text-xs mt-1">
          {{ errors.username }}
        </p>
      </div>

      <label for="email" class="md:ms-auto md:w-25 md:pr-4 text-start md:text-right">email</label>
      <div class="relative">
        <input
          v-model="email"
          v-bind="emailAttrs"
          class="w-full border rounded-sm px-2 py-1 focus:outline-offset-2 focus:outline-4"
          :class="
            errors.email
              ? 'border-red-500 focus:outline-red-400'
              : 'border-gray-500 focus:outline-emerald-400'
          "
          type="email"
          placeholder="email@xxx.com"
        />
        <p v-if="errors.email" class="absolute text-red-500 text-xs mt-1">
          {{ errors.email }}
        </p>
      </div>

      <label for="password" class="md:ms-auto md:w-25 md:pr-4 text-start md:text-right"
        >password</label
      >
      <div class="relative">
        <input
          v-model="password"
          v-bind="passwordAttrs"
          class="w-full border border-gray-500 rounded-sm px-2 py-1 focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400"
          :class="
            errors.password
              ? 'border-red-500 focus:outline-red-400'
              : 'border-gray-500 focus:outline-emerald-400'
          "
          type="password"
        />
        <p v-if="errors.password" class="absolute text-red-500 text-xs mt-1">
          {{ errors.password }}
        </p>
      </div>

      <button
        class="m-auto col-span-1 md:col-span-2 bg-emerald-500 p-2 text-white rounded-4xl cursor-pointer hover:bg-emerald-600 focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400 active:bg-emerald-600 w-40 md:w-50"
        type="submit"
        name="submit"
      >
        {{ isProcessing ? '処理中...' : 'アカウント作成' }}
      </button>
    </form>
  </AuthFormLayout>
</template>
